import { render, staticRenderFns } from "./MegaMenuViewCategory.vue?vue&type=template&id=4179694b&"
import script from "./MegaMenuViewCategory.vue?vue&type=script&lang=js&"
export * from "./MegaMenuViewCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports